import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { VehicleDetails } from 'src/app/interfaces/vehicle-details';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Report } from 'src/app/interfaces/report';
import { ReportRow } from 'src/app/interfaces/report-row';
import { ClaimDetails, ClaimVrmValidate } from 'src/app/interfaces/claim-details';
import { Message } from 'src/app/interfaces/message';
import { InvoiceDetails } from 'src/app/interfaces/invoice-details';
import { InvoiceClaim } from 'src/app/interfaces/invoice-claim';
import { ClaimItem } from 'src/app/interfaces/claim-item';
import { InvoiceDocument } from 'src/app/interfaces/invoice-document';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';
import { FullEntity } from 'src/app/interfaces/full-entity';
import { Login } from 'src/app/interfaces/login';
import { IdType } from 'src/app/models/id-type.enum';
import { Note } from 'src/app/interfaces/note';
import { VrmValidateData } from 'src/app/pages/workorders/workitems/vrm/VrmValidateData';
import { Invoice } from 'src/app/interfaces/invoice';
import { KMTDocuments } from 'src/app/interfaces/KMTDocuments';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  private readonly vrmValidateDataUrl = "v1/workitems/vrmvalidate";

  constructor(private http: HttpClient, private apiService: ApiService) { }

  public get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

 public get urlptdesk(): string {
    return this.apiService.getCurentServer(ServerTypes.ptdesk);
  }
  //FF
  public setUnchargeable(claimId): Observable<any> {
    return this.http.post(
      this.url + '/v1/ff/claims/' + claimId + '/unchargeable',
      null
    );
  }

  public getClaimDetails(claimId: string): Observable<ClaimDetails> {
    return this.http.get<ClaimDetails>(
      this.url + requests.claimDetails + claimId
    );
  }

  public getVrmValidate(claimId: string): Observable<ClaimVrmValidate> {
    return this.http.get<ClaimVrmValidate>(
      this.url + requests.claimDetails + claimId + '/vrmvalidate'
    );
  }

  public getVrmValidateData(workItemId: string): Observable<VrmValidateData> {
    return this.http.get<VrmValidateData>(`${this.url}${this.vrmValidateDataUrl}/${workItemId}`);
  }

  public saveVrmValidate(claimId: string, body) {
    return this.http.post<ClaimVrmValidate>(
      this.url + requests.claimDetails + claimId + '/vrmvalidate', body);
  }

  public getClaimImage(claimId: string, filename: string): Observable<string> {
    return this.http.get<string>(
      this.url + requests.claimDetails + claimId + '/images/' + filename
    );
  }

  public getClaimEvents(claimUID: string): Observable<Message[]> {
    return this.http.get<Message[]>(
      this.url + requests.getClaimEvents + claimUID
    );
  }

  public getClaimMessages(claimId: string): Observable<Message[]> {
    return this.http.get<Message[]>(
      `${this.url}${requests.getMessage}?id=${claimId}`
    );
  }

  public getReports(): Observable<Report[]> {
    return this.http.get<Report[]>(this.url + requests.getReports);
  }

    public saveReport(reportId: string, report: any): Observable<void> {
        return this.http.put<void>(`${this.url}/v1/reports/${reportId}`, report);
    }
   
    public resendReportPayment(reportId: string): Observable<void> {
        return this.http.post<void>(`${this.url}/v1/reports/${reportId}/resendpayment/1`, null);
    }

  public getReport(reportId: string): Observable<Report> {
        return this.http.get<Report>(
            this.url + requests.getReports + '/' + reportId
        );
    }
  public createReport(companyId: string): Observable<void> {
    return this.http.post<void>(
      this.url + requests.createtReport + companyId,
      null
    );
  }

  public getReportRows(reportId: string): Observable<ReportRow[]> {
    return this.http.get<ReportRow[]>(
      this.url + requests.getReports + reportId + '/items'
    );
  }

  public getVehicleDetails(vehicle: string): Observable<VehicleDetails> {
    return this.http.get<VehicleDetails>(
      this.url + requests.getVehicleDetails + vehicle
    );
  }

  public getVehicleInvoices(vehicle: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(`${this.url}/v1/vehicles/${vehicle}/invoices`);  
  }

  public getInvoiceDetails(invoice: string): Observable<InvoiceDetails> {
    return this.http.get<InvoiceDetails>(this.url + requests.getInvoiceDetails + invoice);
  }

  public getInvoiceClaims(invoice: string): Observable<InvoiceClaim[]> {
    return this.http.get<InvoiceClaim[]>(
      this.url +
      requests.getInvoiceDetails +
      invoice +
      requests.getInvoiceClaims
    );
  }

  public getInvoiceClaimItems(invoice: string): Observable<InvoiceClaim[]> {
    return this.http.get<InvoiceClaim[]>(
      this.url +
      requests.getInvoiceDetails +
      invoice +
      requests.getInvoiceClaims
    );
  }

  public getInvoiceDocuments(invoice: string): Observable<InvoiceDocument[]> {
    return this.http.get<InvoiceDocument[]>(
      this.url +
      requests.getInvoiceDetails +
      invoice +
      requests.getInvoiceDocuments
    );
  }

   public getUploadedDocuments(invoice: string): Observable<InvoiceDocument[]> {
    return this.http.get<InvoiceDocument[]>(
      this.url +
     "/v1/ce/files/invoiceId/" +
      invoice 
    );
  }

  public getInvoiceDocumentsById(invoice: string, documentId: string): Observable<InvoiceDocument[]> {
    return this.http.get<InvoiceDocument[]>(
      `${this.url}/v1/invoices/${invoice}/documents/${documentId}`
    );
  }

  public getDocumentById(documentId: string): Observable<InvoiceDocument> {
    return this.http.get<InvoiceDocument>(this.url + requests.getDocuments + documentId);
  }


  // ptdesk renders the document from its id alone — no invoice needed, so this
  // serves documents that belong to one and documents that do not.
  public getDocumentPdf(documentId: string): Observable<Blob> {
    return this.http.get(`${this.urlptdesk}/documents/${documentId}/pdf`, { responseType: 'blob' });
  }

  public getInvoiceAttachments(invoice: string, documentId: string, attachmentIndex: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.url}v1/invoices/${invoice}/documents/${documentId}/attachments/${attachmentIndex}`, { 
      responseType: 'blob',
      observe: 'response'
    });
  }

  public getUploadedPdf(documentId: string): Observable<string> {
    // Get the PDF as a base64 string
    return this.http.get(
      `${this.apiService.getCurentServer(ServerTypes.ptdesk)}/Files/${documentId}?path=Penalty`,
      { 
        responseType: 'text'
      }
    );
  }
  public deleteUploadedPdf(mediaId: string): Observable<any> {
    // Delete the uploaded PDF
    return this.http.delete(
      `${this.apiService.getCurentServer(ServerTypes.ptdesk)}/Files/${mediaId}?path=Penalty`
    );
  }

  public getObjectionDocument(mediaId: string): Observable<Blob> {    
    return this.http.get(`${this.url}v1/documents/media/vDoc.Images.AzureStorageProvider/${mediaId}/?binary=true&name=file.pdf&folder=objection`, { responseType: 'blob' });
  }


  public removeClaimItems(body): Observable<any> {
    return this.http.request(
      'DELETE',
      this.url + requests.claimDetails + 'claimitems',
      { body: body }
    );
  }

  public setHold(claimId, body): Observable<any> {
    return this.http.post(
      this.url + requests.claimDetails + claimId + '/hold',
      body
    );
  }
  public removeHold(claimId, body): Observable<any> {
    return this.http.post(
      this.url + requests.claimDetails + claimId + '/removehold',
      body
    );
  }
    
 public triggerIdentification(vehicleId): Observable < any > {
     return this.http.post(`${this.url}v1/ids/requests/${vehicleId}/triggeridentification`, null);
}


  public postAction(actiontype, body): Observable<any> {
    return this.http.post(this.url + '/v1/actions/' + actiontype, body);
  }

  public cancelInvoice(invoiceId, body): Observable<any> {
     return this.http.request('DELETE', `${this.url}v1/invoices/${invoiceId}`, { body: body });
  }

  public writeoffInvoice(invoiceId, body): Observable<any> {
    return this.http.request('DELETE', `${this.url}v1/invoices/${invoiceId}/writeoff`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: body });
  }

  public undoInvoice(invoiceId, body): Observable<any> {
    return this.http.request('DELETE', `${this.url}v1/invoices/${invoiceId}/undo`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: body });
  }

  public regenDocument(documentId): Observable<any> {
    return this.http.patch(`${this.url}v1/documents/${documentId}/regen`, null);
  }

  public setInvoiceOnHold(invoiceId, body): Observable<any> {
    return this.http.post(`${this.url}v1/invoices/${invoiceId}/hold`, body);
  }

  public removeInvoiceHold(invoiceId, body): Observable<any> {
    return this.http.request('DELETE', `${this.url}v1/invoices/${invoiceId}/hold`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: body });
  }

  public getFullEntity(entityId: string): Observable<FullEntity> {
    return this.http.get<FullEntity>(
      `${this.url}${requests.entityData}${entityId}/full`
    );
  }

  public getLogins(vehicleId: string): Observable<Login[]> {
    return this.http.get<Login[]>(
      `${this.url}${requests.auth}${vehicleId}/sessionlogs`
    );
  }
  public getNotes(type: IdType, id: string): Observable<Note[]> {
    return this.http.get<Note[]>(`${this.url}${requests.note}/${type}/${id}`);
  }
  public getEvents(type: IdType, id: string): Observable<Note[]> {
    return this.http.get<Note[]>(`${this.url}${requests.getPenaltyEvents}/${id}`);
  }
    public saveVehicle(vehicleId, body): Observable<any> {
        return this.http.put(`${this.url}/v1/vehicles/${vehicleId}`, body);
  }
  public updateFxRate(invoiceId: string): Observable<any> {
    return this.http.patch(`${this.url}/v1/invoices/${invoiceId}/updatefxrate`, null);
  }
}
